import React from 'react'
import { IStatusPanelParams } from 'ag-grid-community'

interface Props extends IStatusPanelParams {}

interface State {
  totalCount: number
  filteredCount: number
}

class TotalRowCountStatusPanel extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { totalCount: 0, filteredCount: 0 }
    props.api.addEventListener('modelUpdated', this.updateCount)
  }

  componentWillUnmount() {
    const api = this.props.api
    if (api) {
      api.removeEventListener('modelUpdated', this.updateCount)
    }
  }

  private updateCount = () => {
    const api = this.props.api
    let totalCount = 0
    let filteredCount = 0
    api.forEachNode(node => {
      if (node.data) {
        totalCount++
      }
    })
    api.forEachNodeAfterFilter(node => {
      if (node.data) {
        filteredCount++
      }
    })
    this.setState({ totalCount, filteredCount })
  }

  render() {
    const { totalCount, filteredCount } = this.state
    const localeText = this.props.api.getGridOption('localeText') || {}
    const label = localeText.totalAndFilteredRows ?? 'Rows'
    const ofLabel = localeText.of ?? 'of'

    if (filteredCount < totalCount) {
      return (
        <span>
          {filteredCount} {ofLabel} {totalCount} {label}
        </span>
      )
    }
    return (
      <span>
        {totalCount} {label}
      </span>
    )
  }
}

export default TotalRowCountStatusPanel
